import cn from "classnames";
import { formatPhoneNumber } from "helpers/system";
import React, { useMemo, useState } from "react";

const PhoneNumber = (props) => {
    const { phone } = props;
    const [show, setShow] = useState(false);
    const formattedPhone = useMemo(() => formatPhoneNumber(phone), [phone]);

    if (!phone) {
        return null;
    }

    return (
        <div className="phonenumber">
            <span className={cn("phonenumber__item-phone", { "phonenumber__item-phone--muted": !show })}>
                {show ? formattedPhone : "+7 (900) XXX-XX-XX"}
            </span>
            <span
                className={cn("phonenumber__item-phone-toggler", { "phonenumber__item-phone-toggler--show": show })}
                onClick={() => {
                    setShow(!show);
                    if (props.onClick) {
                        props.onClick();
                    }
                }}
            />
        </div>
    );
};

export default PhoneNumber;
